<template>
  <el-dialog
    title="导入"
    width="700px"
    :visible.sync="dialogVisible"
    :before-close="handleClose">
    <upload-excel :on-success="onSuccess"/>
  </el-dialog>
</template>

<script>
  import uploadExcel from "@/components/UploadExcel/index"

  export default {
    name: "uploadExcelDialog",
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      hred: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    return: {

    },
    components: {
      uploadExcel
    },
    methods: {
      handleClose() {
        this.$emit('update:dialogVisible',false)
      },
      onSuccess(values) {
        let paramList = []
        const hred = this.hred
        for (const result of values.results) {
          const param = {}
          for (const key in result) {
            if (hred[key]) { param[hred[key]] = result[key] }
          }
          paramList.push(param)
        }
        this.$emit('uploadSuccess',paramList)
      }
    }
  }
</script>

<style scoped>

</style>
